import React, { PureComponent, createRef, RefObject } from 'react'
import { StyleSheet } from 'react-native'
import { WebView, WebViewProps } from 'react-native-webview'
import source from './source'

type ManagedProps =
  | 'source'
  | 'injectedJavaScript'
  | 'onMessage'
  | 'onContentProcessDidTerminate'
  | 'originWhitelist'
  | 'ref'

interface ChartProps extends Omit<WebViewProps, ManagedProps> {
  initScript: string
  onChange?: (event: any) => void
}

export default class Chart extends PureComponent<ChartProps> {
  chart: RefObject<WebView | null> = createRef()

  repaint = (script: string) => this.chart.current?.injectJavaScript(script)

  onContentProcessDidTerminate = () => this.chart.current?.reload()

  onMessage = (event: { nativeEvent: { data: string } }) => {
    const data = JSON.parse(event.nativeEvent.data)
    // The chart HTML emits `{ type: 'longPress', ... }` events without an
    // `items` array, but downstream onChange consumers (e.g.
    // useChartInteractions.onChartHover) read `payload.items[0]` and throw
    // on longPress. The upstream wrapper used to route longPress to a
    // separate `onLongPress` prop that no consumer ever set, effectively
    // swallowing these events. Preserve that behavior here until a real
    // longPress handler is wired up.
    if (data?.type === 'longPress') {
      return
    }
    this.props.onChange?.(data)
  }

  render() {
    const { initScript, onChange: _onChange, ...props } = this.props

    return (
      <WebView
        javaScriptEnabled
        scrollEnabled={false}
        style={styles.webView}
        {...props}
        ref={this.chart}
        source={source}
        originWhitelist={['*']}
        injectedJavaScript={initScript}
        onMessage={this.onMessage}
        onContentProcessDidTerminate={this.onContentProcessDidTerminate}
      />
    )
  }
}

const styles = StyleSheet.create({
  webView: {
    flex: 1,
    backgroundColor: 'transparent',
  },
})
